/**
 * WordPress dependencies
 */

import { applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { InnerBlocks } from '@wordpress/block-editor'
import { compose } from '@wordpress/compose'

/**
 * External dependencies
 */
import { withUniqueClass } from '~cartzillagb/higher-order'
import classnames from 'classnames'

const save = props => {
	const {
		className,
		rowClass,
		enableContainer,
		enableGutter,
	} = props.attributes

	const mainClasses = classnames( [
		'czgb-columns-block',
		className,
	], applyFilters( 'cartzillagb.columns.main-block.classes', {
		'container' : enableContainer,
	}, props ) )

	return (
		<Fragment>
			<div className={ mainClasses }>
				<div className={ classnames( [ rowClass, 'czgb-columns-block__inner', 'row', enableGutter === false && 'no-gutters' ] ) }>
					<InnerBlocks.Content />
				</div> 
			</div>
		</Fragment>
	)
}

export default compose(
	withUniqueClass,
)( save )